// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const CancelIcon = (props: IconProps) => (
  <Icon viewBox="0 0 48 48" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0048 18.0053C18.2782 17.732 18.7214 17.732 18.9948 18.0053L29.9948 29.0053C30.2681 29.2787 30.2681 29.7219 29.9948 29.9953C29.7214 30.2686 29.2782 30.2686 29.0048 29.9953L18.0048 18.9953C17.7315 18.7219 17.7315 18.2787 18.0048 18.0053Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.9948 18.0053C30.2681 18.2787 30.2681 18.7219 29.9948 18.9953L18.9948 29.9953C18.7214 30.2686 18.2782 30.2686 18.0048 29.9953C17.7315 29.7219 17.7315 29.2787 18.0048 29.0053L29.0048 18.0053C29.2782 17.732 29.7214 17.732 29.9948 18.0053Z"
      fill="currentColor"
    />
  </Icon>
);
